import { render, staticRenderFns } from "./Contractual.vue?vue&type=template&id=4f94b122&"
import script from "./Contractual.vue?vue&type=script&lang=js&"
export * from "./Contractual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
